const translations = {
  "en": {
    "Final Score": "Final Score"
  },
  "zh-tw": {
    "Final Score": "綜合評分"
  }
};

export default translations;
